import React, { useState } from 'react';
import { Card, FormControl, MenuItem, Select } from '@mui/material';
import { useDispatch } from 'react-redux';
import Popup from '../../../globalcomponents/Popup';
import PopupTitle from '../../../globalcomponents/PopupComponents/PopupHeader';
import PopupBody from '../../../globalcomponents/PopupComponents/PopupBody';
import PopupFooter from '../../../globalcomponents/PopupComponents/PopupFooter';
import Button from '../../../globalcomponents/Button';
import { useTheme } from 'styled-components';
import { transferLeadAgent } from '../../../Redux/util/Apis/leads';
import {
  setGlobalError,
  setSuccessInfo
} from '../../../Redux/Reducer/GlobalError';

const OwnerTransfer = props => {
  const {
    openReason,
    setOpenReason,
    reasonList,
    selectedLeadId,
    leasingAgent,
    refetchLeadInfo
  } = props;
  const [selectedAgent, setSelectedAgent] = useState({});
  const [reason, setReason] = useState('');
  const dispatch = useDispatch();
  const theme = useTheme();
  const handleSelect = e => {
    setSelectedAgent(reasonList.find(({ name }) => name === e.target.value));
  };

  const Save = async () => {
    if (!selectedAgent?.name) return;
    setOpenReason(false);
    const { data, error } = await transferLeadAgent(
      selectedLeadId,
      selectedAgent.name,
      reason
    );
    if (data) {
      dispatch(setSuccessInfo('Lead transferred successfully!'));
      refetchLeadInfo?.();
    }
    if (error) {
      dispatch(setGlobalError(error));
    }
  };
  return (
    <>
      {openReason && (
        <Popup width={'400px'}>
          <PopupTitle showCloseBtn onClose={() => setOpenReason(false)}>
            Transfer Lead
          </PopupTitle>
          <PopupBody>
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  marginBottom: '10px',
                  color: theme?.text?.primary
                }}
              >
                <label className="customPopUpDropDownLabel">
                  Select lead owner
                </label>
                <FormControl
                  sx={{
                    m: 1,
                    minWidth: 325
                  }}
                >
                  <Select
                    value={selectedAgent?.name || leasingAgent?.name || ''}
                    displayEmpty
                    onChange={e => handleSelect(e)}
                    inputProps={{ 'aria-label': 'Without label' }}
                    sx={{
                      border: `1px solid ${theme?.border?.primary}`,
                      color: theme?.text?.primary,
                      '& .MuiOutlinedInput-input.MuiSelect-select': {
                        color: theme?.text?.primary
                      }
                    }}
                  >
                    {reasonList?.map(a => {
                      return (
                        <MenuItem
                          className="customPopUpdropdownMenu"
                          key={a.name}
                          value={a.name}
                        >
                          {a.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                  marginBottom: '10px',
                  color: theme?.text?.primary
                }}
              >
                <label className="customPopUpDropDownLabel">
                  Reason for transfer
                </label>
                <div>
                  <textarea
                    id="outlined-multiline-static"
                    value={reason}
                    onChange={e => setReason(e.target.value)}
                    maxLength={500}
                    placeholder="Please describe the reason for transfer"
                    style={{
                      width: '100%',
                      border: `1px solid ${theme?.border?.primary}`,
                      borderRadius: '4px',
                      fontFamily: 'Inter, sans-serif',
                      background: theme?.background?.secondary,
                      color: theme?.text?.primary
                    }}
                  />
                </div>
              </div>
            </div>
          </PopupBody>
          <PopupFooter padding="10px 20px">
            <Button onClick={() => Save()} btnType="primary">
              Save
            </Button>
            <Button noStyle onClick={e => setOpenReason(false)}>
              Clear
            </Button>
          </PopupFooter>
        </Popup>
      )}
    </>
  );
};

export default OwnerTransfer;
